import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DragDropContext } from "react-beautiful-dnd";
import { Droppable } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";
import formJSON from "Views/Private/FormBuilder/JSON/saveform.json";
import settingJSON from "Views/Private/FormBuilder/JSON/savesetting.json";
import FormHeader from "Views/Private/FormBuilder/FormHeader";
import FormLeftbar from "Views/Private/FormBuilder/FormLeftbar";
import FormRightbar from "Views/Private/FormBuilder/FormRightbar";
import Shorttext from "Views/Private/FormBuilder/FormElement/Shorttext";
import DropDown from "Views/Private/FormBuilder/FormElement/DropDown";
import Longtext from "Views/Private/FormBuilder/FormElement/Longtext";
import Numbers from "Views/Private/FormBuilder/FormElement/Numbers";
import Description from "Views/Private/FormBuilder/FormElement/Description";
import YesNoChoose from "Views/Private/FormBuilder/FormElement/YesNoChoose";
import Checkbox from "Views/Private/FormBuilder/FormElement/Checkbox";
import Radiobutton from "Views/Private/FormBuilder/FormElement/Radiobutton";
import FileDownload from "Views/Private/FormBuilder/FormElement/FileDownload";
import FileUpload from "Views/Private/FormBuilder/FormElement/FileUpload";
import Dates from "Views/Private/FormBuilder/FormElement/Dates";
import Times from "Views/Private/FormBuilder/FormElement/Times";
import SectnTitle from "Views/Private/FormBuilder/FormElement/SectnTitle";
import PageBreak from "Views/Private/FormBuilder/FormElement/PageBreak";
import Emails from "Views/Private/FormBuilder/FormElement/Emails";
import Confirmations from "Views/Private/FormBuilder/FormElement/Confirmations";
import AutoComplete from "Views/Private/FormBuilder/FormElement/AutoComplete";
import Paragraph from "Views/Private/FormBuilder/FormElement/Paragraph";
import VideoComp from "Views/Private/FormBuilder/FormElement/VideoComp";
import Images from "Views/Private/FormBuilder/FormElement/Images";
import MultiInput from "Views/Private/FormBuilder/FormElement/MutiInput";
import Rating from "Views/Private/FormBuilder/FormElement/Rating";
import VideoRecord from "Views/Private/FormBuilder/FormElement/VideoRecord";
import MultiCheckbox from "Views/Private/FormBuilder/FormElement/MultiCheckbox";
import {
  FORM_BUILDER_FORM_DETAILS_URL_LATEST,
  SETTING_FORM_URL,
} from "Constant/api";
import { authService } from "Service/Axios";
import { paths } from "Constant/paths";
import Signature from "../../FormElement/Signature";
import Website from "../../FormElement/Website";
import Address from "../../FormElement/Address";
import PhoneNo from "../../FormElement/PhoneNo";

export const FormDesign = () => {
  const { formId } = useParams();

  const [viewForm, setviewForm] = useState(formJSON[0]);
  const [settings, setsettings] = useState(false);
  const [viewSetting, setviewSetting] = useState(settingJSON);
  const [openset, setopenset] = useState("");
  const k = Math.floor(100000 + Math.random() * 900000);
  const z = Math.floor(100000 + Math.random() * 900000);
  const [eleavailable, seteleavailable] = useState([
    {
      questionId: z,
      sectionId: z,
      description: k,
      questionName: "",
      label: "",
      columnSpan: 1,
      placeholderText: "",
      fieldDescription: "",
      required: false,
      hidden: false,
      internal: false,
      sequenceNo: 0,
      typename: "",
      controlNo: 1,
      cssname: "fa-fa-envelope-o",
      dropdownValues: [],
      dropdown: 0,
      dropdownDeafultValueCheck: false,
      dropdownDeafultValue: {},
      minimumLengthCheck: false,
      minimumLength: null,
      maximumLengthCheck: false,
      maximumLength: null,
      dropdownapi: "",
      dropdownapiValues: [],
      parentQuestionName: "",
      fileuploadtypes: [],
      value: [],
      numericValue: [],
      addrule: false,
      show: false,
      mainConditions: [],
      validation: false,
      mapping: false,
      objectmap: "",
      fieldmap: "",
      autoSearchEvent: false,
      autoSearch: "",
      uniqueValue: false,
      autoSearchKey: "",
      calculate: false,
      calculateType: null,
      calculateValueType: null,
      calculation: null,
      calculateQuestionId: 0,
      calulateOthersCond: [],
      calulateOthersMultiSelect: [],
      calulateOthersValue: "",
      videoURL: "",
      imageURL: "",
      ratingNo: 0,
      gridOneChoiceRow: false,
      gridOneChoiceColumn: false,
      gridMultiChoceRow: false,
    },
  ]);
  const [globalList, setGlobalList] = useState([]);
  const [pagebk, setpagebk] = useState([
    {
      pageId: k,
      name: "",
      sequenceNo: 0,
      type: "",
      sections: [],
    },
  ]);

  const getData = (data) => {
    if (data?.Type == "pgbreak") {
      let alpha = [
        ...pagebk.filter((item) => item.pageId != data?.questionID),
        {
          pageId: pagebk.filter((item) => item.pageId == data?.questionID)[0]
            ?.pageId,
          name: data?.field,
          sequenceNo: pagebk.filter(
            (item) => item.pageId == data?.questionID
          )[0]?.sequenceNo,
          type: data?.Type?.length > 0 ? data.Type : openset,
          sections: [],
        },
      ];

      setpagebk(alpha.sort((a, b) => a.sequenceNo - b.sequenceNo));
    } else {
      let alpha = [
        ...eleavailable.filter((item) => item.questionId != data?.questionID),
        {
          questionId: eleavailable.filter(
            (item) => item.questionId == data?.questionID
          )[0]?.questionId,
          sectionId: eleavailable.filter(
            (item) => item.questionId == data?.questionID
          )[0]?.sectionId,
          description: eleavailable.filter(
            (item) => item.questionId == data?.questionID
          )[0]?.description,
          questionName: data?.field,
          label: data?.question,
          columnSpan: parseInt(data?.colsel),
          placeholderText: data?.placehold,
          fieldDescription: data?.descrip,
          required: data?.mandatory,
          hidden: data?.hiden,
          internal: data?.intrnl,
          sequenceNo: eleavailable.filter(
            (item) => item.questionId == data?.questionID
          )[0]?.sequenceNo,
          typename: data?.Type?.length > 0 ? data.Type : openset,
          controlNo: 1,
          cssname: "fa-fa-envelope-o",
          dropdown: 0,
          dropdownValues: data?.droparr,
          dropdownDeafultValueCheck: data?.NegNum,
          dropdownDeafultValue: {},
          minimumLengthCheck: false,
          minimumLength: data?.minLength,
          maximumLengthCheck: false,
          maximumLength: data?.maxLength,
          dropdownapi: data?.charType,
          dropdownapiValues: [],
          parentQuestionName: data?.dynamo,
          fileuploadtypes: data?.uploadCheck,
          value: [],
          numericValue: data?.numberCheck,
          addrule: data?.rul,
          show: data?.sow,
          mainConditions: data?.logConditn,
          validation: data?.valide,
          mapping: data?.boolMapping,
          objectmap: data?.mapVal,
          fieldmap: data?.toVal,
          autoSearchEvent: data?.boolautoSearchEvent,
          autoSearch: data?.autoSel,
          uniqueValue: data?.unq,
          autoSearchKey: data?.autoKey,
          calculate: data?.calc,
          calculateType: data?.calcType,
          calculateValueType: data?.calcValueType,
          calculation: data?.calcValue,
          paragraph: data?.paragraph,
          calculateQuestionId: 0,
          calulateOthersCond: data?.calulateOtherslogConditn,
          calulateOthersMultiSelect: data?.calulateOthersdroparr,
          calulateOthersValue: data?.calulateOtherVal,
          videoURL: data?.videoUrl,
          imageURL: data?.imgUrl,
          ratingNo: data?.rateStar,
          gridOneChoiceRow: data?.gridOneChoiceRowBool,
          gridOneChoiceColumn: data?.gridOneChoiceColumnBool,
          gridMultiChoceRow: data?.gridMultiChoceRowBool,
          global: data?.glbflag,
          gridRows: data?.rowMulti,
          gridColumns: data?.colMulti,
        },
      ];
      seteleavailable(alpha.sort((a, b) => a.sequenceNo - b.sequenceNo));
    }
  };

  const handleDragDrop = (result) => {
    const { destination, source, draggableId } = result;
    if (!destination) return;

    if (
      draggableId == "short" ||
      draggableId == "long" ||
      draggableId == "number" ||
      draggableId == "description" ||
      draggableId == "toggle_on" ||
      draggableId == "drop_on" ||
      draggableId == "check_on" ||
      draggableId == "mutiple_on" ||
      draggableId == "fileUp" ||
      draggableId == "fileDown" ||
      draggableId == "dates" ||
      draggableId == "times" ||
      draggableId == "emails" ||
      draggableId == "confirms" ||
      draggableId == "auto_complete" ||
      draggableId == "paragraph" ||
      draggableId == "video" ||
      draggableId == "record" ||
      draggableId == "image" ||
      draggableId == "rate" ||
      draggableId == "multiinp" ||
      draggableId == "multiChecks" ||
      draggableId == "sectn" ||
      draggableId == "signature" ||
      draggableId == "loc" ||
      draggableId == "call" ||
      draggableId == "web"
    ) {
      setopenset(draggableId);
      let arr = eleavailable.map((item) => {
        if (item.sequenceNo > parseInt(destination.droppableId.split("_")[1])) {
          return { ...item, sequenceNo: item.sequenceNo + 2 };
        } else return { ...item };
      });
      let id = eleavailable.filter(
        (i) => i.sequenceNo == destination.droppableId.split("_")[1]
      )[0]?.sectionId;
      let unq = Math.floor(100000 + Math.random() * 900000);
      let res = [
        ...arr,
        {
          questionId: unq,
          sectionId: draggableId == "sectn" ? unq : id,
          description: pagebk[pagebk.length - 1].pageId,
          questionName: "",
          label: "",
          columnSpan: 1,
          placeholderText: "",
          fieldDescription: "",
          required: false,
          hidden: false,
          internal: false,
          sequenceNo: parseInt(destination.droppableId.split("_")[1]) + 1,
          typename: draggableId,
          controlNo: 1,
          cssname: "fa-fa-envelope-o",
          dropdownValues: [],
          dropdown: 0,
          dropdownDeafultValueCheck: false,
          dropdownDeafultValue: {},
          minimumLengthCheck: false,
          minimumLength: null,
          maximumLengthCheck: false,
          maximumLength: null,
          dropdownapi: "",
          dropdownapiValues: [],
          parentQuestionName: "",
          fileuploadtypes: [],
          value: [],
          numericValue: [],
          addrule: false,
          show: false,
          mainConditions: [],
          validation: false,
          mapping: false,
          objectmap: "",
          fieldmap: "",
          autoSearchEvent: false,
          autoSearch: "",
          uniqueValue: false,
          autoSearchKey: "",
          calculate: false,
          calculateType: null,
          calculateValueType: null,
          calculation: null,
          calculateQuestionId: 0,
          calulateOthersCond: [],
          calulateOthersMultiSelect: [],
          calulateOthersValue: "",
          videoURL: "",
          imageURL: "",
          ratingNo: 0,
          gridOneChoiceRow: false,
          gridOneChoiceColumn: false,
          gridMultiChoceRow: false,
          gridRows: [],
          gridColumns: [],
        },
      ];
      seteleavailable(res.sort((a, b) => a.sequenceNo - b.sequenceNo));
    } else if (draggableId == "pgbreak") {
      setopenset(draggableId);
      const mn = Math.floor(100000 + Math.random() * 900000);
      setpagebk([
        ...pagebk.map((item) => {
          return { ...item, type: draggableId };
        }),
        {
          pageId: mn,
          name: "",
          sequenceNo: pagebk.length,
          type: draggableId,
          sections: [],
        },
      ]);
    } else if (parseInt(draggableId) != NaN && draggableId.length == 5) {
      setopenset(
        globalList.filter((i) => i.globalId == draggableId)[0]?.elementType
      );
      let arr = eleavailable.map((item) => {
        if (item.sequenceNo > parseInt(destination.droppableId.split("_")[1])) {
          return {
            ...item,
            sequenceNo:
              item.sequenceNo +
              2 +
              globalList.filter((i) => i.globalId == draggableId)[0]?.questions
                ?.length,
          };
        } else return { ...item };
      });
      let id = eleavailable.filter(
        (i) => i.sequenceNo == destination.droppableId.split("_")[1]
      )[0]?.sectionId;
      let unq = Math.floor(100000 + Math.random() * 900000);
      const payload = {
        elementType: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.elementType,
        questionId: unq,
        formId: formId,
        sectionId:
          globalList.filter((i) => i.globalId == draggableId)[0]?.elementType ==
            "sectn"
            ? unq
            : id,
        label: globalList.filter((i) => i.globalId == draggableId)[0]?.label,
        sequenceNo: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.sequenceNo,
        editfield: {
          questionName: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.questionName,
          placeholderText: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.placeholderText,
          fieldDescription: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.fieldDescription,
          required: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.required,
          hidden: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.hidden,
          internal: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.internal,
          columnSpan: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.columnSpan,
          parentQuestionName: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.parentQuestionName,
          dropdownValues: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.dropdownValues,
          fileuploadtypes: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.fileuploadtypes,
          mapping: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.mapping,
          objectmap: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.objectmap,
          fieldmap: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.fieldmap,
          sectionDescription: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.sectionDescription,
          paragraph: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.paragraph,
          autoSearch: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.autoSearch,
          autoSearchEvent: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.autoSearchEvent,
          uniqueValue: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.uniqueValue,
          autoSearchKey: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.autoSearchKey,
          gridRows: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.gridRows,
          gridColumns: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.gridColumns,
        },
        validateField: {
          fieldLength: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.fieldLength,
          minimumLength: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.minimumLength,
          maximumLength: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.maximumLength,
          charcterType: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.charcterType,
          charcterTypeValue: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.validateField.charcterTypeValue,
          patternType: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.patternType,
          patternTypeValue: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.validateField.patternTypeValue,
          numericType: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.numericType,
          numericValue: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.numericValue,
          numberRange: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.numberRange,
          numberRangeValue: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.validateField.numberRangeValue,
          measurement: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.measurement,
          measurementValue: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.validateField.measurementValue,
          negativeNumber: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.negativeNumber,
          validation: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.validation,
        },
        globalField: false,
        globalId: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.globalId,
        addrule: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.addrule,
        show: globalList.filter((i) => i.globalId == draggableId)[0]?.show,
        mainConditions: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.mainConditions,
        calculate: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.calculate,
        calculateType: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.calculateType,
        calculateValueType: globalList.filter(
          (i) => i.globalId == draggableId
        )[0]?.calculateValueType,
        calculation: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.calculation,
        calulateOthersCond: globalList.filter(
          (i) => i.globalId == draggableId
        )[0]?.calulateOthersCond,
        calulateOthersMultiSelect: globalList.filter(
          (i) => i.globalId == draggableId
        )[0]?.calulateOthersMultiSelect,
        calulateOthersValue: globalList.filter(
          (i) => i.globalId == draggableId
        )[0]?.calulateOthersValue,
        videoURL: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.videoURL,
        imageURL: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.imageURL,
        ratingNo: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.ratingNo,
        gridOneChoiceRow: globalList.filter((i) => i.globalId == draggableId)[0]
          ?.gridOneChoiceRow,
        gridOneChoiceColumn: globalList.filter(
          (i) => i.globalId == draggableId
        )[0]?.gridOneChoiceColumn,
        gridMultiChoceRow: globalList.filter(
          (i) => i.globalId == draggableId
        )[0]?.gridMultiChoceRow,
      };
      authService(SETTING_FORM_URL, "POST", payload);

      let res = [
        ...arr,
        {
          questionId: unq,
          sectionId:
            globalList.filter((i) => i.globalId == draggableId)[0]
              ?.elementType == "sectn"
              ? unq
              : id,
          description: pagebk[pagebk.length - 1].pageId,
          questionName: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.questionName,
          label: globalList.filter((i) => i.globalId == draggableId)[0]?.label,
          columnSpan: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.columnSpan,
          placeholderText: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.placeholderText,
          fieldDescription: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.fieldDescription,
          required: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.required,
          hidden: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.hidden,
          internal: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.internal,
          sequenceNo: parseInt(destination.droppableId.split("_")[1]) + 1,
          typename: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.elementType,
          controlNo: 1,
          cssname: "fa-fa-envelope-o",
          minimumLength: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.minimumLength,
          maximumLength: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.maximumLength,
          parentQuestionName: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.parentQuestionName,
          dropdownValues: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.dropdownValues,
          fileuploadtypes: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.fileuploadtypes,
          value: [],
          numericValue: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.numericValue,
          validation: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.validateField.validation,
          mapping: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.mapping,
          objectmap: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.objectmap,
          fieldmap: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.fieldmap,
          autoSearch: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.autoSearch,
          autoSearchEvent: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.editfield.autoSearchEvent,
          uniqueValue: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.uniqueValue,
          autoSearchKey: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.autoSearchKey,
          globalId: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.globalId,
          addrule: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.addrule,
          show: globalList.filter((i) => i.globalId == draggableId)[0]?.show,
          mainConditions: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.mainConditions,
          calculate: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.calculate,
          calculateType: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.calculateType,
          calculateValueType: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.calculateValueType,
          calculation: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.calculation,
          calulateOthersCond: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.calulateOthersCond,
          calulateOthersMultiSelect: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.calulateOthersMultiSelect,
          calulateOthersValue: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.calulateOthersValue,
          videoURL: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.videoURL,
          imageURL: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.imageURL,
          ratingNo: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.ratingNo,
          gridOneChoiceRow: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.gridOneChoiceRow,
          gridOneChoiceColumn: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.gridOneChoiceColumn,
          gridMultiChoceRow: globalList.filter(
            (i) => i.globalId == draggableId
          )[0]?.gridMultiChoceRow,
          gridRows: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.gridRows,
          gridColumns: globalList.filter((i) => i.globalId == draggableId)[0]
            ?.editfield.gridColumns,
          dropdownapi: "",
          dropdownapiValues: [],
          dropdown: 0,
          dropdownDeafultValueCheck: false,
          dropdownDeafultValue: {},
          minimumLengthCheck: false,
          maximumLengthCheck: false,
        },
      ];
      if (
        globalList.filter((i) => i.globalId == draggableId)[0]?.elementType ==
        "sectn"
      ) {
        const temp = globalList
          .filter((i) => i.globalId == draggableId)[0]
          ?.questions.map((item, index) => {
            authService(SETTING_FORM_URL, "POST", {
              ...item,
              sectionId: unq,
              formId: formId,
            });
            return {
              questionId: item.questionId,
              sectionId: unq,
              description: pagebk[pagebk.length - 1].pageId,
              questionName: "",
              label: item.label,
              columnSpan: 1,
              placeholderText: "",
              fieldDescription: "",
              required: false,
              hidden: false,
              internal: false,
              sequenceNo:
                parseInt(destination.droppableId.split("_")[1]) + 2 + index,
              typename: item.elementType,
              controlNo: 1,
              cssname: "fa-fa-envelope-o",
              dropdownValues: [],
              dropdown: 0,
              dropdownDeafultValueCheck: false,
              dropdownDeafultValue: {},
              minimumLengthCheck: false,
              minimumLength: null,
              maximumLengthCheck: false,
              maximumLength: null,
              dropdownapi: "",
              dropdownapiValues: [],
              parentQuestionName: "",
              fileuploadtypes: [],
              value: [],
              numericValue: [],
              addrule: false,
              show: false,
              mainConditions: [],
              validation: false,
              mapping: false,
              objectmap: "",
              fieldmap: "",
              autoSearchEvent: false,
              autoSearch: "",
              uniqueValue: false,
              autoSearchKey: "",
              calculate: false,
              calculateType: null,
              calculateValueType: null,
              calculation: null,
              calculateQuestionId: 0,
              calulateOthersCond: [],
              calulateOthersMultiSelect: [],
              calulateOthersValue: "",
              videoURL: "",
              imageURL: "",
              ratingNo: 0,
              gridOneChoiceRow: false,
              gridOneChoiceColumn: false,
              gridMultiChoceRow: false,
              gridRows: [],
              gridColumns: [],
            };
          });
        res = [...res, ...temp];
      }
      seteleavailable(res.sort((a, b) => a.sequenceNo - b.sequenceNo));
    } else if (
      draggableId != "pgbreak" &&
      draggableId != "sectn" &&
      draggableId != "short" &&
      draggableId != "long" &&
      draggableId != "number" &&
      draggableId != "description" &&
      draggableId != "toggle_on" &&
      draggableId != "drop_on" &&
      draggableId != "check_on" &&
      draggableId != "mutiple_on" &&
      draggableId != "fileUp" &&
      draggableId != "fileDown" &&
      draggableId != "dates" &&
      draggableId != "times" &&
      draggableId != "emails" &&
      draggableId != "confirms" &&
      draggableId != "auto_complete" &&
      draggableId != "paragraph" &&
      draggableId != "video" &&
      draggableId != "record" &&
      draggableId != "image" &&
      draggableId != "rate" &&
      draggableId != "multiChecks" &&
      draggableId != "multiinp" &&
      draggableId != "signature" &&
      draggableId != "loc" &&
      draggableId != "call" &&
      draggableId != "web"
    ) {
      const items = Array.from(eleavailable);
      let [reorderedItem] = items.splice(source.index, 1);
      let id = eleavailable.filter(
        (i) => i.sequenceNo == destination.index - 1
      )[0]?.sectionId;
      reorderedItem = { ...reorderedItem, sectionId: id };
      items.splice(destination.index, 0, reorderedItem);
      let beta = items.map((ele, index) => {
        return { ...ele, sequenceNo: index };
      });
      seteleavailable(beta.sort((a, b) => a.sequenceNo - b.sequenceNo));
    }
  };

  const navigate = useNavigate();

  const viewFormAction = async () => {
    const payload = { formId: formId };
    const response = await authService(
      FORM_BUILDER_FORM_DETAILS_URL_LATEST,
      "POST",
      payload
    );
    if (response) {
      setviewForm(response);
      if (!response.success) navigate(paths.formBuilder.dashboard);
      // update
      if (response.pages?.length > 0) {
        setpagebk(
          response.pages.map((item) => {
            return {
              pageId: item.pageId,
              name: item.name,
              sequenceNo: item?.sequenceNo,
              type: item.type,
              sections: [],
            };
          })
        );

        response.pages?.map(function (i) {
          let arr = [];
          if (i.questions?.length > 0) {
            arr = i.questions?.map((item, index) => {
              return {
                questionId: item.questionId,
                sectionId: item.sectionId,
                description: item.description,
                questionName: item.questionName,
                label: item.label,
                columnSpan: item.columnSpan,
                placeholderText: item.placeholderText,
                fieldDescription: item.fieldDescription,
                paragraph: item.paragraph,
                required: item.required,
                hidden: item.hidden,
                internal: item.internal,
                sequenceNo: item?.sequenceNo,
                typename: item.typename,
                controlNo: item.controlNo,
                cssname: item.cssname,
                dropdown: item.dropdown,
                dropdownValues: item.dropdownValues,
                dropdownDeafultValueCheck: item.dropdownDeafultValueCheck,
                dropdownDeafultValue: item.dropdownDeafultValue,
                minimumLengthCheck: item.minimumLengthCheck,
                minimumLength: item.minimumLength,
                maximumLengthCheck: item.maximumLengthCheck,
                maximumLength: item.maximumLength,
                dropdownapi: item.dropdownapi,
                dropdownapiValues: item.dropdownapiValues,
                parentQuestionName: item.parentQuestionName,
                fileuploadtypes: item.fileuploadtypes,
                value: item.value,
                numericValue: item.numericValue,
                addrule: item.addrule,
                show: item.show,
                mainConditions: item.mainConditions,
                validation: item.validation,
                mapping: item.mapping,
                objectmap: item.objectmap,
                fieldmap: item.fieldmap,
                autoSearchEvent: item.autoSearchEvent,
                autoSearch: item.autoSearch,
                uniqueValue: item.uniqueValue,
                autoSearchKey: item.autoSearchKey,
                calculate: item.calculate,
                calculateType: item.calculateType,
                calculateValueType: item.calculateValueType,
                calculation: item.calculation,
                calculateQuestionId: item.calculateQuestionId,
                calulateOthersCond: item.calulateOthersCond,
                calulateOthersMultiSelect: item.calulateOthersMultiSelect,
                calulateOthersValue: item.calulateOthersValue,
                videoURL: item.videoURL,
                imageURL: item.imageURL,
                ratingNo: item.ratingNo,
                gridOneChoiceRow: item.gridOneChoiceRow,
                gridOneChoiceColumn: item.gridOneChoiceColumn,
                gridMultiChoceRow: item.gridMultiChoceRow,
                gridRows: item.gridRows,
                gridColumns: item.gridColumns,
              };
            });
          }
          this.push(...arr);
          seteleavailable(this);
        }, []);
      }
    }
  };

  useEffect(() => {
    viewFormAction();
  }, viewForm);

  const getForm = (data) => {
    setviewForm(data);
    //viewFormAction();
  };

  return (
    <DragDropContext onDragEnd={handleDragDrop}>
      <div className="formeditor-wrapper shadow-1 box-shadow-3">
        {viewForm && (
          <FormHeader
            rcvForm={getForm}
            dataForm={eleavailable}
            page={pagebk}
            flag={true}
          />
        )}
        <div className="d-flex flex-wrap rounded-bottom overflow-hidden align-items-start bg-white rounded-bottom-3 formbuilder-body">
          <Droppable droppableId="some_id">
            {(provided, snapshot) => {
              return (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <FormLeftbar
                    globalList={globalList}
                    setGlobalList={setGlobalList}
                  />
                </div>
              );
            }}
          </Droppable>
          <div className="formeditor-view ms-auto sidebar-right p-3 border-end border-start scroll-y h-100">
            {pagebk?.map(function (item, index, arr) {
              return (
                <>
                  <div
                    key={item.pageId}
                    className="p-3 rounded-2 bg-white border"
                  >
                    {this.length > 0 &&
                      this?.filter((i) => i.description == item.pageId)?.map(
                        (element, index, arr) => {
                          return (
                            <Droppable
                              droppableId={`diff_${element.sequenceNo}`}
                            >
                              {(provided, snapshot) => (
                                <div
                                  className="row"
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  <Draggable
                                    key={element.questionId}
                                    draggableId={element.questionId.toString()}
                                    index={element.sequenceNo}
                                  >
                                    {(provided) => {
                                      const transform =
                                        provided.draggableProps?.style
                                          ?.transform;
                                      if (transform) {
                                        const t = transform.split(",")[1];
                                        provided.draggableProps.style.transform = `translate(0px,${t}`;
                                      }
                                      return (
                                        <div
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          ref={provided.innerRef}
                                          style={{
                                            ...provided.draggableProps.style,
                                          }}
                                        >
                                          {element?.typename == "sectn" && (
                                            <SectnTitle
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={element?.label}
                                              fieldDescription={
                                                element?.fieldDescription
                                              }
                                              viewForm={element?.sectionId}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={element?.typename}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={element?.sequenceNo}
                                            />
                                          )}
                                          {element.typename == "short" && (
                                            <Shorttext
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "long" && (
                                            <Longtext
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "paragraph" && (
                                            <Paragraph
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "number" && (
                                            <Numbers
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "web" && (
                                            <Website
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "call" && (
                                            <PhoneNo
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "loc" && (
                                            <Address
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename ==
                                            "description" && (
                                              <Description
                                                status={"save"}
                                                setsettings={setsettings}
                                                eleavailable={eleavailable?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                viewForm={[item]?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                setviewSetting={setviewSetting}
                                                settings={settings}
                                                seteleavailable={seteleavailable}
                                                allElements={eleavailable}
                                                formId={formId}
                                                setfirst={() => { }}
                                                first={[]}
                                                setviewForm={setviewForm}
                                                dynaDDselarr={viewForm}
                                              />
                                            )}
                                          {element.typename ==
                                            "signature" && (
                                              <Signature
                                                status={"save"}
                                                setsettings={setsettings}
                                                eleavailable={eleavailable?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                viewForm={[item]?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                setviewSetting={setviewSetting}
                                                settings={settings}
                                                drop={""}
                                                seteleavailable={seteleavailable}
                                                allElements={eleavailable}
                                                formId={formId}
                                                setfirst={() => { }}
                                                first={[]}
                                                setviewForm={setviewForm}
                                                dynaDDselarr={viewForm}
                                              />
                                            )}
                                          {element.typename == "drop_on" && (
                                            <DropDown
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "toggle_on" && (
                                            <YesNoChoose
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "check_on" && (
                                            <Checkbox
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename ==
                                            "multiChecks" && (
                                              <MultiCheckbox
                                                status={"save"}
                                                setsettings={setsettings}
                                                eleavailable={eleavailable?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                viewForm={[item]?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                setviewSetting={setviewSetting}
                                                settings={settings}
                                                seteleavailable={seteleavailable}
                                                allElements={eleavailable}
                                                formId={formId}
                                                setfirst={() => { }}
                                                first={[]}
                                                setviewForm={setviewForm}
                                                dynaDDselarr={viewForm}
                                              />
                                            )}
                                          {element.typename == "mutiple_on" && (
                                            <Radiobutton
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "fileUp" && (
                                            <FileUpload
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "fileDown" && (
                                            <FileDownload
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "dates" && (
                                            <Dates
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "times" && (
                                            <Times
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "emails" && (
                                            <Emails
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "confirms" && (
                                            <Confirmations
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename ==
                                            "auto_complete" && (
                                              <AutoComplete
                                                status={"save"}
                                                setsettings={setsettings}
                                                eleavailable={eleavailable?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                viewForm={[item]?.filter(
                                                  (item) =>
                                                    item.questionId ==
                                                    arr[index].questionId
                                                )}
                                                setviewSetting={setviewSetting}
                                                settings={settings}
                                                seteleavailable={seteleavailable}
                                                allElements={eleavailable}
                                                formId={formId}
                                                setfirst={() => { }}
                                                first={[]}
                                                setviewForm={setviewForm}
                                                dynaDDselarr={viewForm}
                                              />
                                            )}
                                          {element.typename == "video" && (
                                            <VideoComp
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "record" && (
                                            <VideoRecord
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "image" && (
                                            <Images
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "rate" && (
                                            <Rating
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                          {element.typename == "multiinp" && (
                                            <MultiInput
                                              status={"save"}
                                              setsettings={setsettings}
                                              eleavailable={eleavailable?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              viewForm={[item]?.filter(
                                                (item) =>
                                                  item.questionId ==
                                                  arr[index].questionId
                                              )}
                                              setviewSetting={setviewSetting}
                                              settings={settings}
                                              seteleavailable={seteleavailable}
                                              allElements={eleavailable}
                                              formId={formId}
                                              setfirst={() => { }}
                                              first={[]}
                                              setviewForm={setviewForm}
                                              dynaDDselarr={viewForm}
                                            />
                                          )}
                                        </div>
                                      );
                                    }}
                                  </Draggable>
                                  {this.length < 2 && (
                                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
                                      <div className="drag-drop-box py-5 px-3 d-flex justify-content-center align-items-center rounded-2 bg-light height-equal">
                                        Drag and Drop your field
                                      </div>
                                    </div>
                                  )}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          );
                        }
                      )}
                    <Droppable droppableId={item?.pageId.toString()}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {item?.type == "pgbreak" && (
                            <PageBreak
                              status={"save"}
                              setsettings={setsettings}
                              eleavailable={item?.name}
                              viewForm={item?.pageId}
                              setviewSetting={setviewSetting}
                              settings={settings}
                              setpagebk={setpagebk}
                              allElements={arr}
                              formId={formId}
                              setcounter={() => { }}
                              counter={item?.type}
                              setviewForm={setviewForm}
                              dynaDDselarr={item?.sequenceNo}
                            />
                          )}
                        </div>
                      )}
                    </Droppable>
                  </div>
                  <hr />
                </>
              );
            }, eleavailable)}
          </div>
          {settings && (
            <FormRightbar
              openset={openset}
              rcvData={getData}
              settingData={viewSetting}
              availQid={formId}
              settings={settings}
              setsettings={setsettings}
              dynamicDd={eleavailable}
              rcvForm={getForm}
              dataForm={eleavailable}
              page={pagebk}
            />
          )}
        </div>
      </div>
    </DragDropContext>
  );
};
